export default __webpack_public_path__ + "static/media/team-foto1.ed3ceba0.png";